var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSynaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 368.5 133.2",
    style: {
      enableBackground: "new 0 0 368.5 133.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#635F5B;}\n\t.st1{fill:#FFC300;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.3,39l-24.6,66c-6.5,17.4-16.4,27-33.1,27h-6.5c-2.3,0-4.2-1.2-4.2-5.6v-2.3c0-4.5,2-5.7,4.2-5.7h3 c8.1,0,14-4.8,17.4-14.1l0.9-2.4L76.3,39c-1.1-2.7,0.3-5.1,6.6-5.1h5.6c6.3,0,8.4,2.4,9.3,5.1l14.3,42.8L125.3,39 c0.8-2.7,3-5.1,9.3-5.1h3C144.1,33.9,145.3,36.3,144.3,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.5,99.8V60.3c0-18.5,11.3-27.9,33.2-27.9c21.8,0,33.2,9.5,33.2,27.9v39.5c0,2.7-1.7,5.1-7.7,5.1h-4.5 c-6.2,0-7.8-2.4-7.8-5.1V60.9c0-9.5-3.8-13.7-13.2-13.7c-9.6,0-13.4,4.2-13.4,13.7v38.9c0,2.7-1.5,5.1-7.7,5.1h-4.5 C149,104.9,147.5,102.5,147.5,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M286.8,57.3v26.3c0,16.2-10.1,22.8-32.2,22.8c-22.5,0-32.8-7.2-32.8-21.2v-1.5c0-13.8,9.6-20.3,29.8-21.3 l16.4-0.9v-2c0-8.1-4.4-12.2-14.4-12c-5.9,0-13.4,1.7-18.6,3.5l-3.6,1.4c-3,0.8-4.5,0.1-5.4-3.5l-1.1-4.7 c-0.8-3.2-0.1-4.7,2.4-5.7l5.3-2c6.9-2.7,14.9-4.2,23.7-4.2C277.9,32.4,286.8,41.2,286.8,57.3z M268,83.6v-11l-11.9,0.6 c-10.1,0.6-14.9,3.5-14.9,10.2v1.4c0,6.8,3.3,10.1,13.4,10.1C264.2,94.9,268,91.4,268,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.2,101.9l-7.7-2.5c-3-1.1-3.9-3-2.9-6.8L3,87.8c1.2-4.2,2.9-4.8,6.2-3.9l5.9,1.9 c6.5,2.1,15.3,4.1,23.6,4.1c12.8,0,19.1-4.4,19.1-12.5c0-7.1-5-9.2-15.6-12.5L29,61.1C13,56.4,2.6,49.3,2.6,32.8 C2.6,14.3,16,1.1,40.9,1.3c9.8,0,18.5,1.8,25.5,4.2l6.8,2.4c2.9,1.1,3.8,2.9,2.9,6.5l-1.4,5c-1.2,4.2-2.7,4.8-5.9,3.8l-5.1-1.7 c-6-2-13.5-3.8-21.2-3.8c-12.8,0-18.2,4.8-18.2,12.6c0,7.8,5.3,9.9,15.2,12.9l13.2,3.9c17.7,5,26.9,12,26.9,27.9 c0,19.1-13.7,31.4-39.7,31.4C29.3,106.4,19.9,104.6,12.2,101.9z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 294.7,
    y: 32.4,
    className: "st1",
    width: 72.6,
    height: 72.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynaLogo);
export default __webpack_public_path__ + "static/media/syna_logo.866b76500d86cfbd010de1ab7ddeeda4.svg";
export { ForwardRef as ReactComponent };